// extracted by mini-css-extract-plugin
export default {"searchIcon":"search-field_searchIcon__0C+x1","clearIcon":"search-field_clearIcon__Z6hJf"};